import { render, staticRenderFns } from "./Notifications_List.vue?vue&type=template&id=0f4b1ca6&scoped=true&"
import script from "./Notifications_List.vue?vue&type=script&lang=js&"
export * from "./Notifications_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4b1ca6",
  null
  
)

export default component.exports